import { httpClientUser } from 'Api/microservice-http-clients';
import { getUrlParamsByObject } from 'Utils/url';

export async function getWalletData(accountId) {
  const { data } = await httpClientUser.get(`/account/${accountId}/wallet`);
  return data;
}

export async function postWalletFundingSource(accountId, fundingSource) {
  const { data } = await httpClientUser.post(`/account/${accountId}/wallet/funding-source`, fundingSource);
  return data?.id;
}

export function deleteWalletFundingSource(accountId, fundingSource) {
  return httpClientUser.delete(`/account/${accountId}/wallet/funding-source`, fundingSource);
}

export async function getWalletAddBankAccountLinkToken(accountId) {
  const { data } = await httpClientUser.get(`/account/${accountId}/wallet/create-link-token`);
  return data?.link_token || '';
}

export async function getWalletActivationBeneficialOwnerList(accountId) {
  const { data } = await httpClientUser.get(`/account/${accountId}/wallet/verification/beneficial-owner`);
  return data;
}

export async function getWalletTransaction(accountId, limit, offset) {
  const { data } = await httpClientUser.get(`/account/${accountId}/wallet/transaction${getUrlParamsByObject({ limit, offset })}`);
  return data;
}

export async function deleteWalletTransaction(accountId, transactionId) {
  return httpClientUser.delete(`/account/${accountId}/wallet/transaction`, { id: transactionId });
}
